import { useTranslation } from 'react-i18next';
import { WHATSAPP_BASE } from '@/constants';

interface DealerHeroProps {
  onApply: () => void;
}

export default function DealerHero({ onApply }: DealerHeroProps) {
  const { t } = useTranslation();
  const whatsappHref = `${WHATSAPP_BASE}?text=${encodeURIComponent(t('whatsapp.message'))}`;

  return (
    <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden pt-24 md:min-h-[680px]">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://storage.helloreaddy.io/project_files/23cbf37b-3b60-45d6-b458-2fbb3e9ec10a/08b57743-7d7c-4a2a-9051-d88c4793a586_compressed_1.webp')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-20 text-center md:px-6">
        <p className="reveal mb-6 text-xs uppercase tracking-[0.4em] text-primary-400 md:text-sm">
          {t('dealer.badge')}
        </p>
        <h1 className="reveal reveal-delay-1 font-heading text-3xl leading-tight text-background-50 md:text-5xl lg:text-6xl">
          {t('dealer.heroTitle')}
        </h1>
        <p className="reveal reveal-delay-2 mt-6 max-w-2xl text-base leading-relaxed text-background-100/85 md:text-lg">
          {t('dealer.heroSubtitle')}
        </p>

        <div className="reveal reveal-delay-3 mt-10 flex flex-col items-center gap-4 sm:flex-row">
          <button
            type="button"
            onClick={onApply}
            className="whitespace-nowrap rounded-md bg-primary-500 px-8 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400 cursor-pointer"
          >
            {t('dealer.heroCta')}
          </button>
          <a
            href={whatsappHref}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="whitespace-nowrap rounded-md border border-background-100/50 px-8 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:border-primary-500 hover:text-primary-400"
          >
            {t('final.cta2')}
          </a>
        </div>
      </div>
    </section>
  );
}